/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { IconButton, Tooltip } from "@common-ui/ui";
import {
  // PauseCircle,
  PlayCircle,
  StopCircle,
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import {
  getWorkItemTimes,
  updateWorkEventStatus,
  updateWorkItem,
  workItemLogger,
} from "../../services";

import { useDispatch, useSelector } from "react-redux";

import { workItemsSlice } from "../../reducers/workItemsReducer";
import { workEventSlice } from "../../reducers/workEventReducer";
// import { last } from "lodash";

export function TimeController(props) {
  const dispatch = useDispatch();
  const [workTimes, setWorkTimes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [started, setStarted] = useState(false);

  const currentOrg = useSelector(
    (state) => state.organization.currentOrganization
  );
  const newWorkItems = useSelector((state) => state.workItems);
  // console.log("newWorkItems", newWorkItems);
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (workTimes?.length) {
      if (workTimes[workTimes.length - 1]?.action === "START") {
        setStarted(true);
        dispatch(
          workItemsSlice.actions.setActionButtonState({
            workItemId: props?.row?.id,
            actionButtonState: "START",
          })
        );
      }
    } else {
      setStarted(false);
      dispatch(
        workItemsSlice.actions.setActionButtonState({
          workItemId: props?.row?.id,
          actionButtonState: "STOP",
        })
      );
    }
  }, [JSON.stringify([workTimes])]);

  // console.log("started", started);
  useEffect(() => {
    // if (props.completed) {
    //   if (workTimes?.length && !workTimes[workTimes.length - 1].end) {
    //     // stop();
    //     logTime("STOP");
    //   }
    // } else {
    // if (workTimes?.length && props.started) {
    //   logTime("START");
    // }
    // }
  }, [props.completed]);
  async function init(action = undefined) {
    try {
      let workTimes = await getWorkItemTimes(
        props?.row?.work_event,
        props?.row?.id
      );
      // console.log("workTimes", workTimes, props?.row?.id);
      if (action) {
        dispatch(
          workItemsSlice.actions.setActionButtonState({
            workItemId: props?.row?.id,
            actionButtonState: action,
          })
        );
        setStarted(action === "START" ? true : false);
      } else {
        if (workTimes?.length) {
          if (workTimes[workTimes?.length - 1]?.action === "START") {
            expandTable();
            dispatch(
              workItemsSlice.actions.setActionButtonState({
                workItemId: props?.row?.id,
                actionButtonState: "START",
              })
            );
            setStarted(true);
          } else {
            collapseTable();
            dispatch(
              workItemsSlice.actions.setActionButtonState({
                workItemId: props?.row?.id,
                actionButtonState: "STOP",
              })
            );
            setStarted(false);
          }
        } else {
          collapseTable();
          dispatch(
            workItemsSlice.actions.setActionButtonState({
              workItemId: props?.row?.id,
              actionButtonState: "STOP",
            })
          );
          setStarted(false);
        }
      }
      if (workTimes?.length) {
        dispatch(
          workItemsSlice.actions.setStarted({ workItemId: props?.row?.id })
        );
      }
      setWorkTimes(workTimes);
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  }

  function expandTable() {
    let currentExpanded = props?.params?.api?.getExpandedDetailPanels
      ? props?.params?.api?.getExpandedDetailPanels()
      : [];
    props?.params?.api?.setExpandedDetailPanels &&
      props?.params?.api?.setExpandedDetailPanels([
        ...currentExpanded,
        props?.row?.id,
      ]);
  }
  function collapseTable() {
    let currentExpanded = getExpandedIds();
    props?.params?.api?.setExpandedDetailPanels &&
      props?.params?.api?.setExpandedDetailPanels(
        currentExpanded?.filter((item) => item !== props?.row?.id)
      );
  }

  const getExpandedIds = () => {
    let currentExpanded = props?.params?.api?.getExpandedDetailPanels
      ? props?.params?.api?.getExpandedDetailPanels()
      : [];
    return currentExpanded;
  };
  async function logTime(action) {
    setIsLoading(true);
    try {
      if (action === "START") {
        let currentExpanded = getExpandedIds();

        let otherExpanded = currentExpanded?.filter(
          (item) => item !== props?.row?.id
        );
        let allWorkItemKeys = Object.keys(newWorkItems);
        let otherWorkItemKeys = allWorkItemKeys.filter(
          (item) => item !== props?.row?.id
        );
        let shouldAlert = false;
        otherWorkItemKeys.forEach((element) => {
          if (newWorkItems[element].actionButtonState === "START") {
            shouldAlert = true;
          }
        });
        if (shouldAlert) {
          alert(`Please stop the previous work item!`);
          return setIsLoading(false);
        }

        if (otherExpanded?.length) {
          alert(`Please stop other work item: ${String(otherExpanded)} first.`);
          return setIsLoading(false);
        }
      }
      await workItemLogger(action, props?.row?.work_event, props?.row?.id);
      const statusValue = props.completed ? "COMPLETED" : "IN_PROGRESS";
      const attributes = {
        status: statusValue,
      };
      if (statusValue === "IN_PROGRESS") {
        if (action === "START") {
        }
        await updateWorkItem(
          attributes,
          props?.row?.work_event,
          props?.row?.id,
          currentOrg?.id
        );
        dispatch(
          workItemsSlice.actions.setWorkItemStatus({
            workItemId: props?.row?.id,
            status: statusValue,
          })
        );
        await updateWorkEventStatus(
          currentOrg?.id,
          props?.row?.work_event,
          attributes
        );
        dispatch(
          workEventSlice.actions.setWorkEventStatus({
            id: props?.row?.work_event,
            status: statusValue,
          })
        );
      }
      await init(action);
      if (action) {
        if (action === "START") {
          expandTable();
        } else if (action === "STOP") {
          collapseTable();
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  return "";
  //   if (props.completed) {
  //     return (
  //       <Tooltip title="Start">
  //         <IconButton disabled={props.completed}>
  //           <PlayCircle aria-label="start" />{" "}
  //         </IconButton>
  //       </Tooltip>
  //     );
  //   }
  //   if (!workTimes?.length) {
  //     return (
  //       <Tooltip title="Start">
  //         <IconButton
  //           onClick={() => {
  //             logTime("START");
  //           }}
  //         >
  //           <PlayCircle aria-label="start" />{" "}
  //         </IconButton>
  //       </Tooltip>
  //     );
  //   } else {
  //     return !started ? (
  //       <Tooltip title="Start">
  //         <div>
  //           <IconButton
  //             disabled={isLoading ? true : props.completed || props.isDraft}
  //             onClick={() => logTime("START")}
  //           >
  //             <PlayCircle
  //               disabled={isLoading}
  //               color={
  //                 isLoading
  //                   ? "disabled"
  //                   : props.completed || props.isDraft
  //                   ? "disabled"
  //                   : "primary"
  //               }
  //               aria-label="start"
  //             />
  //           </IconButton>
  //         </div>
  //       </Tooltip>
  //     ) : (
  //       <Tooltip title="Stop">
  //         <div>
  //           <IconButton disabled={isLoading} onClick={() => logTime("STOP")}>
  //             <StopCircle disabled={isLoading} aria-label="stop" />
  //           </IconButton>
  //         </div>
  //       </Tooltip>
  //     );
  //   }
}
